import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxUtility from '../util/remote/ajaxUtility';

const initialState = { 
    searchText: '',
    searchActive: false,
    message: 'Enter keyword in the search bar to get started',
    searchResults: '404',
    searchLogId: 0,
    recentSearches: false,
    searchSuggestions: false
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
};


const FinderContext = createContext();

export const FinderProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(()=>{
    if(state.searchText){
      getSearchResults();
    }
  }, [state.searchText])


  const setSearchText = (text) =>{
    dispatch({type: 'searchText', payload: text})
  }

  const toggleSearch = (value)=>{
    dispatch({type: 'searchActive', payload: value})
  }

  const getSearchResults = async () =>{
      
      dispatch({type: 'searchResults', payload: false});
      dispatch({type: 'message', payload: ''});

      const server_response = await ajaxUtility.searchSystem(state.searchText);
      if(server_response.status === "OK"){
        dispatch({type: 'searchResults', payload: server_response.details});
        dispatch({type: 'searchLogId', payload: server_response.details.log_id});
        getRecentSearches();

      }else{
        dispatch({type: 'message', payload: server_response.message});
        dispatch({type: 'searchResults', payload: '404'});
      }
  } 

  const logResultClick = async (result_type, title, subtitle, content)=>{
    await ajaxUtility.logItem(state.searchLogId, result_type, title, subtitle, content);
    await getSuggestions();
  }

  const getRecentSearches = async ()=>{
    const server_response = await ajaxUtility.fetchRecentSearch();
    if(server_response.status === "OK"){
      dispatch({type: 'recentSearches', payload: server_response.details});
    }else{
      dispatch({type: 'recentSearches', payload: '404'});

    }
  }

  const getSuggestions = async ()=>{
    const server_response = await ajaxUtility.fetchSearchSuggestions();
    if(server_response.status === "OK"){
      dispatch({type: 'searchSuggestions', payload: server_response.details});
    }else{
      dispatch({type: 'searchSuggestions', payload: '404'});

    }
  }

  return(
    <FinderContext.Provider value={{
      ...state, 
      dispatch,
      setSearchText,
      toggleSearch,
      logResultClick,
      getRecentSearches,
      getSuggestions,
      }}>
      {children}
    </FinderContext.Provider>
  )

}

export const useFinder = ()=>useContext(FinderContext);

